import React from 'react';

import './Druckverlust.css';
import { calculateDruckverlust, calculateHydraulischerDurchmesser, calculateZeta, interpolieren } from '../calculations/pressureLoss';

class Druckverlust extends React.Component {
    constructor(props) {
    super(props);

    this.state = {
             daten: [],

    };
    }

    druckverlust(){
        return calculateDruckverlust({
            Anstroemgeschwindigkeit: this.props.Anstroemgeschwindigkeit,
            Kulissenspaltbreite: this.props.Kulissenspaltbreite,
            Kulissenbreite: this.props.Kulissenbreite,
            Kulissenhoehe: this.props.Kulissenhoehe,
            Kulissenlaenge: this.props.Kulissenlaenge,
            AnzahlKulissen: this.props.AnzahlKulissen,
        });
    }

    hydraulischerDurchmesser(){
        return calculateHydraulischerDurchmesser({
            Kulissenspaltbreite: this.props.Kulissenspaltbreite,
            Kulissenhoehe: this.props.Kulissenhoehe,
            AnzahlKulissen: this.props.AnzahlKulissen,
        });
    }

    interpolieren(xm,x1,x2,y1,y2){
        return interpolieren(xm,x1,x2,y1,y2);
    }

    zeta(){
        return calculateZeta({
            Kulissenspaltbreite: this.props.Kulissenspaltbreite,
            Kulissenbreite: this.props.Kulissenbreite,
            Kulissenhoehe: this.props.Kulissenhoehe,
            Kulissenlaenge: this.props.Kulissenlaenge,
            AnzahlKulissen: this.props.AnzahlKulissen,
        });
    }





  render() {
      return <>{this.druckverlust().toFixed(0)}</>;

  }
}
export default Druckverlust;
